module.exports = __webpack_public_path__ + "static/img/2023_9_8_2.eee17adf.eee17ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/2023_9_8_2.eee17adf.jpg
// module id = mUDU
// module chunks = 0